import React from 'react';
import { useDispatch } from 'react-redux';
import { hideModal } from 'src/redux/actions/modalActions';

const ConfirmationModal = ({ title, message, onConfirm, confirmText = 'Confirm', cancelText = 'Cancel', confirmButtonClass = 'bg-[#832EE6] hover:bg-purple-700', showCloseButton = true, iconType = 'info' }) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideModal());
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    handleClose();
  };

  const getIcon = () => {
    switch (iconType) {
      case 'warning':
        return (
          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-yellow-100 flex-shrink-0 mr-3">
            <svg className="h-5 w-5 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
        );
      case 'danger':
        return (
          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-red-100 flex-shrink-0 mr-3">
            <svg className="h-5 w-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
        );
      case 'info':
      default:
        return (
          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-blue-100 flex-shrink-0 mr-3">
            <svg className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        );
    }
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4 relative overflow-hidden">
        {showCloseButton && (
          <button 
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-500 transition-colors"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}

        <div className="flex flex-col">
          <div className="flex items-center mb-4">
            {iconType && getIcon()}
            {title && (
              <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
            )}
          </div>
          
          {message && (
            <p className="text-gray-600 text-sm md:text-base mb-6">
              {message}
            </p>
          )}
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={handleClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-50 transition-all duration-200"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className={`px-4 py-2 text-white font-medium rounded-md transition-all duration-200 ${confirmButtonClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;

